<template>
  <div class="confirmation-container">
    <div v-if="loading" class="text-center">
      <div class="spinner-border text-danger mb-3" role="status">
        <span class="visually-hidden">Eliminando...</span>
      </div>
      <p class="text-muted">Eliminando usuario...</p>
    </div>
    
    <div v-else class="text-center">
      <div class="warning-icon mb-3">
        <i class="fas fa-exclamation-triangle text-warning" style="font-size: 3rem;"></i>
      </div>
      
      <h5 class="mb-3">¿Estás seguro?</h5>
      
      <p class="text-muted mb-0">
        ¿Deseas eliminar a 
        <strong class="text-dark">{{ fullName }}</strong> 
        como usuario de tu plan de Utel X?
      </p>
      
      <div class="alert alert-warning mt-3 mb-0" role="alert">
        <small>
          <i class="fas fa-info-circle me-1"></i>
          Esta acción no se puede deshacer.
        </small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmationMessage',
  
  props: {
    student: { type: Object, required: true },
    loading: { type: Boolean, default: false }
  },

  computed: {
    fullName() {
      return `${this.student.firstname || ''} ${this.student.lastname || ''}`.trim() || 'Usuario'
    }
  }
}
</script>

<style scoped>
.confirmation-container {
  padding: 1rem 0;
}

.warning-icon {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.alert {
  border-radius: 0.5rem;
  font-size: 0.875rem;
}
</style>